import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Image from 'react-bootstrap/Image';
import Card from 'react-bootstrap/Card';
import { useTranslation } from 'react-i18next';

import '../style/servicesPages.css'
import Seo from '../components/Seo';

function Automation(){
    const { t } = useTranslation();

    return(
        <section id='automation' className='block service-block'>
            <Seo path='/services/automation' titleKey='seo.automation.title' descriptionKey='seo.automation.description' />
            <Container fluid style={{marginTop: "50px"}}>
                <div className='title-holder'>
                    <h2>{t('automation.title')}</h2>
                    <div className='subtitle'>{t('automation.subtitle')}</div>
                </div>

                {/* Hero Section */}
                <Row style={{marginTop: "50px"}}>
                    <Col>
                        <div className='service-detail'>
                            <h3>{t('automation.hero.title')}</h3>
                            <p>{t('automation.hero.description')}</p>
                            <div className="alert alert-info mt-4">
                                <i className="fas fa-lightbulb me-2"></i>
                                <strong>{t('automation.hero.highlight')}</strong>
                            </div>
                        </div>
                    </Col>
                    <Col>
                        <div className='image-service'>
                            <Image className='image-service-bootstrap flexible' src={require("../assets/images/crm-automation-gemini.png")} rounded />
                        </div>
                    </Col>
                </Row>

                {/* Services Grid */}
                <div className='intermediate-title' style={{marginTop: "80px", marginBottom: "40px"}}>
                    <h3>{t('automation.servicesTitle')}</h3>
                </div>

                <Row className="g-4" style={{marginBottom: "60px"}}>
                    {/* Task Automation Card */}
                    <Col md={6}>
                        <Card className="h-100 shadow-sm">
                            <Card.Body>
                                <div className="d-flex align-items-center mb-3">
                                    <i className="fas fa-tasks fa-2x text-primary me-3"></i>
                                    <Card.Title as="h4" className="mb-0">{t('automation.services.taskAutomation.title')}</Card.Title>
                                </div>
                                <Card.Text>{t('automation.services.taskAutomation.description')}</Card.Text>
                                <h6 className="mt-4 mb-3">{t('automation.services.taskAutomation.examplesTitle')}</h6>
                                <ul>
                                    <li>{t('automation.services.taskAutomation.items.item1')}</li>
                                    <li>{t('automation.services.taskAutomation.items.item2')}</li>
                                    <li>{t('automation.services.taskAutomation.items.item3')}</li>
                                    <li>{t('automation.services.taskAutomation.items.item4')}</li>
                                    <li>{t('automation.services.taskAutomation.items.item5')}</li>
                                </ul>
                            </Card.Body>
                        </Card>
                    </Col>

                    {/* CRM Automation Card */}
                    <Col md={6}>
                        <Card className="h-100 shadow-sm">
                            <Card.Body>
                                <div className="d-flex align-items-center mb-3">
                                    <i className="fas fa-users-cog fa-2x text-primary me-3"></i>
                                    <Card.Title as="h4" className="mb-0">{t('automation.services.crmAutomation.title')}</Card.Title>
                                </div>
                                <Card.Text>{t('automation.services.crmAutomation.description')}</Card.Text>
                                <h6 className="mt-4 mb-3">{t('automation.services.crmAutomation.examplesTitle')}</h6>
                                <ul>
                                    <li>{t('automation.services.crmAutomation.items.item1')}</li>
                                    <li>{t('automation.services.crmAutomation.items.item2')}</li>
                                    <li>{t('automation.services.crmAutomation.items.item3')}</li>
                                    <li>{t('automation.services.crmAutomation.items.item4')}</li>
                                    <li>{t('automation.services.crmAutomation.items.item5')}</li>
                                </ul>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                {/* Use Cases Section */}
                <Row style={{marginTop: "80px", marginBottom: "60px"}}>
                    <Col>
                        <div className='image-service'>
                            <Image className='image-service-bootstrap flexible' src={require("../assets/images/task-automation-3.jpg")} rounded />
                        </div>
                    </Col>
                    <Col>
                        <div className='service-detail'>
                            <h3>{t('automation.useCases.title')}</h3>
                            <p>{t('automation.useCases.description')}</p>
                            
                            <div className="mt-4">
                                <h5><i className="fas fa-check-circle text-success me-2"></i>{t('automation.useCases.cases.case1.title')}</h5>
                                <p className="ms-4">{t('automation.useCases.cases.case1.description')}</p>
                            </div>
                            
                            <div className="mt-3">
                                <h5><i className="fas fa-check-circle text-success me-2"></i>{t('automation.useCases.cases.case2.title')}</h5>
                                <p className="ms-4">{t('automation.useCases.cases.case2.description')}</p>
                            </div>
                            
                            <div className="mt-3">
                                <h5><i className="fas fa-check-circle text-success me-2"></i>{t('automation.useCases.cases.case3.title')}</h5>
                                <p className="ms-4">{t('automation.useCases.cases.case3.description')}</p>
                            </div>
                        </div>
                    </Col>
                </Row>

                {/* Benefits Section */}
                <div className='intermediate-title' style={{marginTop: "80px", marginBottom: "40px"}}>
                    <h3>{t('automation.benefits.title')}</h3>
                    <p className="lead">{t('automation.benefits.description')}</p>
                </div>

                <Row className="g-4" style={{marginBottom: "60px"}}>
                    <Col md={3}>
                        <div className="text-center p-4">
                            <i className="fas fa-clock fa-3x text-primary mb-3"></i>
                            <h5>{t('automation.benefits.items.item1.title')}</h5>
                            <p>{t('automation.benefits.items.item1.description')}</p>
                        </div>
                    </Col>
                    <Col md={3}>
                        <div className="text-center p-4">
                            <i className="fas fa-chart-line fa-3x text-primary mb-3"></i>
                            <h5>{t('automation.benefits.items.item2.title')}</h5>
                            <p>{t('automation.benefits.items.item2.description')}</p>
                        </div>
                    </Col>
                    <Col md={3}>
                        <div className="text-center p-4">
                            <i className="fas fa-shield-alt fa-3x text-primary mb-3"></i>
                            <h5>{t('automation.benefits.items.item3.title')}</h5>
                            <p>{t('automation.benefits.items.item3.description')}</p>
                        </div>
                    </Col>
                    <Col md={3}>
                        <div className="text-center p-4">
                            <i className="fas fa-dollar-sign fa-3x text-primary mb-3"></i>
                            <h5>{t('automation.benefits.items.item4.title')}</h5>
                            <p>{t('automation.benefits.items.item4.description')}</p>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}

export default Automation;
